import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServiceHelper } from '../config';
import { CustomerModel, CustomerRegistrationRequestModel, GenericResponseModel, ResetPasswordRequestModel } from '../models';
import { AppConfig } from '../config';
import { StateService } from '.';

@Injectable()
export class CustomerService {

    constructor(public http: HttpClient, public serviceHelper: ServiceHelper, private appConfig: AppConfig, private stateService: StateService) {
        var me = this;

        me.getCustomer();

        me.stateService.userModel$.subscribe(user => {
            // console.log('User changed, getting new customer details', user);
            me.getCustomer();
        });
    }

    getCustomer() {
        let me = this;
        me.CurrentCustomer().subscribe(data => {
            me.customer = data;
            // console.log('CurrentCustomer', data);
        });
    }

    customer: CustomerModel;

    CurrentCustomer(): Observable<CustomerModel> {
        let me = this;
        var headers = this.serviceHelper.GetHeaders();

        return this.http.get<CustomerModel>(this.appConfig.getConfig('apiUrl') + '/customers/current', { withCredentials: true, headers: headers });
    }

    UpdateProfile(customer: CustomerModel): Observable<CustomerModel> {
        let me = this;
        var headers = this.serviceHelper.GetHeaders();

        return this.http.put<CustomerModel>(this.appConfig.getConfig('apiUrl') + '/customers/profile', customer, { withCredentials: true, headers: headers });
    }

    UpdatePassword(request: ResetPasswordRequestModel): Observable<any> {
        var headers = this.serviceHelper.GetHeaders();

        var params = JSON.stringify(request);

        return this.http.post(this.appConfig.getConfig('apiUrl') + `/customers/update-password`, params, { withCredentials: true, headers: headers });
    }

    /**
     * Register customer
     * @param request 
     * @returns Response with success status, error code and UserModel if successful
     */
    register(request: CustomerRegistrationRequestModel): Observable<GenericResponseModel> {
        let me = this;
        var headers = this.serviceHelper.GetHeaders();

        return this.http.post<GenericResponseModel>(this.appConfig.getConfig('apiUrl') + '/customers/register', request, { withCredentials: true, headers: headers });
    }
}